import React, { useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Typography from '@material-ui/core/Typography';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Button from '@material-ui/core/Button';
import { Grid, Paper } from "@material-ui/core";
import { Modal, Backdrop, Fade } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import { OutlinedInput, InputAdornment, Tooltip } from "@material-ui/core";
import { Search } from "@material-ui/icons"; // example icon
import { Checkbox } from "@material-ui/core";
import Popover from '@material-ui/core/Popover';
import MenuItem from '@material-ui/core/MenuItem';
import { getDatafromDataModelIdPayload } from '../../utils/payload'
import ModelWithTableViewer from './model'
import { use } from 'react';
import DataTable from '../DataTable/DataTable.js'
import useStyles from './style';

const AttachmentDocumentViewer = (props) => {
    const { block, appId, orgId, formData, selectedStep, blockState, updateDocumentData, documentData, isEditable } = props;
    const { config, conditions } = block;
    const { chartUniqueId, chartData } = props.data
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [open, setOpen] = useState(false);
    const [keyVal, setKey] = useState("")

    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOptions, setMenuOptions] = useState([]);
    const [filterConditions, setFilterConditions] = useState([])

    const [blockHeaders, setBlockHeaders] = useState([])

    const [tableData, setTableData] = useState({});
    const [totalRecords, setTotalRecords] = useState(0);

    const [selectedOptions, setSelectedOptions] = useState({});

    const handleOpen = () => { setOpen(true); setKey(block.dataModel || selectedStep.dataModel) };
    const handleCloseModel = () => setOpen(false);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    let tableRows = []

    const [currentDataModel, setCurrentDataModel] = useState({})


    const fetchDataModel = () => {
        let payload = {
            appid: appId,
            orgId: orgId
        }
        if (block?.dataModel || selectedStep?.dataModel) {
            let ID = block.dataModel || selectedStep.dataModel;
            if (!formData?.dataModel?.[ID]) {
                if (!formData?.dataModel?.[ID] && !formData[`${ID}_loading`]) {
                    payload['dataModelId'] = ID
                    payload['dataUniqueId'] = ID
                    props.getDataModelById(payload)
                }
            } else {
                block?.dataModel ? setCurrentDataModel(formData?.dataModel?.[ID]) : setCurrentDataModel(formData?.dataModel?.[ID])
            }
        }
    }

    useEffect(() => {
        if (formData?.dataModel[block.dataModel || selectedStep.dataModel]) {
            let dataElements = formData.dataModel[block.dataModel || selectedStep.dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                if (block?.config[0]?.dataElements) {
                    fdes = JSON.parse(JSON.stringify(block?.config[0]?.dataElements))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        if (sde?.name) {
                            return {
                                ...sde,
                                ...fde
                            }
                        } else {
                            return fde
                        }
                    })
                    setBlockHeaders(fdes)
                }
            }
        }
    }, [formData?.dataModel])

    const getDatafromDataModelId = (searchKey) => {
        let modelDatapayload = getDatafromDataModelIdPayload(appId, block?.dataModel || selectedStep?.dataModel, page, rowsPerPage, filterConditions)
        if (searchKey) {
            modelDatapayload['search'] = searchKey;
        }
        props.getModelData({ ...modelDatapayload, dataUniqueId: chartUniqueId + '_assosiateddata' });
    }

    useEffect(() => {
        fetchDataModel()
        filterDocIds()
    }, [config])

    useEffect(() => {
        filterDocIds()
    }, [blockState?.[block?.dataElement]])

    const filterDocIds = () => {
        if (blockState[block.dataElement]) {
            let linkedData = blockState[block.dataElement] ? blockState[block.dataElement] : [];

            let docIdsList = []
            linkedData && linkedData.length && linkedData.forEach(obj => {
                if (obj.dataModel === block.dataModel) {
                    docIdsList = obj.documents;
                }
            });

            if (linkedData.length > 0 && docIdsList.length > 0) {
                getDocsfromIds(docIdsList, block.dataModel)
            }
            else {
                setTableData({})
                tableRows = [];
                setTotalRecords(0)
            }
        }
        else {
            setTableData({})
            tableRows = [];
            setTotalRecords(0)
        }

    }

    const getDocsfromIds = (docIdsList, dataModel) => {
        if (docIdsList && docIdsList.length > 0) {
            let payload = {
                fields: 'all',
                docIds: docIdsList,
                appId: appId,
                id: dataModel,
                page: page, rowsPerPage: rowsPerPage,
            };
            props.getDocumentsFromIDsOfOpportunity({ ...payload, dataUniqueId: chartUniqueId + '_documentsfromIds_' + block.dataModel });
        } else {
            setTableData({})
            tableRows = [];
            setTotalRecords(0)
        }
    }

    const clearDocumentsfromIdsChartReduxStore = () => {
        let subKeys = [
            props.data.chartUniqueId + '_documentsfromIds_' + block.dataModel,
        ]
        props.clearReduxDataOfCurrentComponent({
            key: "document",
            subKey: subKeys
        })
    }


    useEffect(() => {
        if (formData?.document[chartUniqueId + '_documentsfromIds_' + block.dataModel]?.length) {
            let dataList = formData?.document[chartUniqueId + '_documentsfromIds_' + block.dataModel] || []
            let total = formData?.document[chartUniqueId + '_documentsfromIds_' + block.dataModel]?.length || []
            if (updateDocumentData) {
                updateDocumentData(block.dataModel, dataList);
            }

            setTableData({ [block.dataModel]: dataList })
            tableRows = dataList;
            setTotalRecords(total)

        } else {
            if (updateDocumentData) {
                updateDocumentData(block.dataModel, []);
            }
            setTableData({})
            tableRows = [];
            setTotalRecords(0)
        }
    }, [props.formData?.document[chartUniqueId + '_documentsfromIds_' + block.dataModel]])

    const handleClick = (event, options) => {
        setAnchorEl(event.currentTarget);
        setMenuOptions(options);
    };

    const handleClose = () => setAnchorEl(null);

    const externalFilter = [
        {
            "value": "vendorLegalEntity",
            "label": "Vendor Legal Entity",
            "type": "string",
            "options": ["All", "Leading supplier of cloud infrastructure solutions", "Specialist in cybersecurity and data protection solutions", "Consulting and advisory services for finance and IT", "Leading supplier of cloud infrastructure solutions", "Specialist in cybersecurity and data protection solutions", "Consulting and advisory services for finance and IT", "Leading supplier of cloud infrastructure solutions", "Specialist in cybersecurity and data protection solutions", "Consulting and advisory services for finance and IT"],
            "showIcon": true
        },
        {
            "value": "effectiveDate",
            "label": "Effective Date",
            "type": "date"
        },
        {
            "value": "expirationDate",
            "label": "Expiration Date",
            "type": "date"
        }
    ]

    const columns = [
        "File Name",
        "Contract Type",
        "Effective Date",
        "Expiration Date",
        "Action"
    ];
    const rows = []

    const columnsss = [
        "checkbox",
        "File Name",
        "Contract Type",
        "Effective Date",
        "Expiration Date",
    ];
    const rowsss = [
        // sample rows (unused)
    ];

    const handleOptionToggle = (option) => {
        setSelectedOptions((prev) => {
            const current = prev[currentField] || [];
            if (current.includes(option)) {
                return { ...prev, [currentField]: current.filter((o) => o !== option) };
            } else {
                return { ...prev, [currentField]: [...current, option] };
            }
        });
    };

    // const handleDeleteModelDocument = (documentId, data) => {
    //     props.onModelClick('delete', data);
    // }

    const handleDeleteDocument = (documentId, data) => {
        if (props.blockState?.linkedReferenceDocuments) {
            const existingLinkedRefs = [...props.blockState.linkedReferenceDocuments];

            const updatedLinkedRefs = existingLinkedRefs.map(item => {
                if (item.dataModel === block.dataModel && item.documents) {
                    return {
                        ...item,
                        documents: item.documents.filter(docId => docId !== documentId)
                    };
                }
                return item;
            }).filter(item => item.documents && item.documents.length > 0);

            if (props.setBlockState) {
                props.setBlockState({
                    ...props.blockState,
                    linkedReferenceDocuments: updatedLinkedRefs
                });
            }

            if (props.updateDocumentData) {
                const currentData = props.documentData?.[block.dataModel] || [];
                const updatedData = currentData.filter(doc => doc._id !== documentId);
                props.updateDocumentData(block.dataModel, updatedData);
            }
            if (props.match?.params?.id && props.onEditModeChange) {
                props.onEditModeChange(true);
            }
        }
    };

    const handleEditClick = (row, index) => {
        console.log('handleEditClick', row, index);
    };

    const handleDeleteClick = (row, index) => {
        console.log('handleDeleteClick', row, index);
    };

    return (
        <div>
            <div className={classes.sectionPadding}>
                <div className={classes.banner}>
                    <img src={'/media/createStepper/contractImages.svg'} className={classes.bannerImg} />
                    <div className={classes.bannerRow}>
                        <Button
                            variant="contained"
                            className={classes.bannerBtn}
                            onClick={() => { handleOpen() }}
                            style={{ backgroundColor: isEditable ? '' : 'transparent', cursor: isEditable ? 'pointer' : 'not-allowed' }}
                            disabled={!isEditable}
                        >
                            {block.buttonText}
                        </Button>
                        <div className={classes.bannerTextWrap}>
                            <Typography className={classes.bannerSubHeading}>
                                {block.subHeading}
                            </Typography>
                            <Typography className={classes.bannerTopHeading}>
                                {block.topHeading}
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>

            {
                (props.formData?.[chartUniqueId + '_documentsfromIds_' + block.dataModel + '_loading'] || props.formData?.[block.dataModel + '_loading']) ? props.loader : (
                    <div className={classes.tableSection}>
                        <Typography className={classes.tableTitle}>
                            {block.tableHeading}
                        </Typography>
                        <DataTable
                            headers={blockHeaders}
                            uniqueId={456}
                            data={tableData[block.dataModel] || []}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            totalRecords={totalRecords}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            actionColumn={isEditable} // Only show action column if editable
                            actionIcon={isEditable ? "/media/createStepper/deleteContracts.svg" : null}
                            onActionClick={isEditable ? (row, idx) => {
                                const documentId = row._id;
                                if (documentId) {
                                    handleDeleteDocument(documentId, row);
                                }
                            } : null}
                            showEditAction={false}
                            onEditClick={isEditable ? (row, idx) => {
                                handleEditClick(row, idx);
                            } : null}
                            showDeleteAction={isEditable}
                            onDeleteClick={isEditable ? (row, idx) => {
                                const documentId = row._id;
                                if (documentId) {
                                    handleDeleteDocument(documentId, row);
                                }
                            } : null}
                            cellStyle={{ borderLeft:'none', borderTop:'none'}}
                            match={props.match} 
                            history={props.history}
                        />
                    </div>
                )
            }

            {
                open && (
                    <ModelWithTableViewer
                        {...props}
                        open={open}
                        handleCloseModel={handleCloseModel}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        selectedOptions={selectedOptions}
                        anchorEl={anchorEl}
                        menuOptions={menuOptions}
                        handleClick={handleClick}
                        handleClose={handleClose}
                        keyVal={keyVal}
                        chartUniqueId={chartUniqueId}
                        block={block}
                        parentBlockState={props.blockState}
                        match={props.match} 
                        history={props.history}
                    />
                )
            }
        </div>
    )
}

export default AttachmentDocumentViewer
